import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ApplicationPdfRequest, IFile, RequestStrategyEnum } from '@shared/api';

interface IApplicationPdfStore {
  loading: boolean;
  error: string | null;
  file: IFile | null;
  getApplicationPdf: (request: ApplicationPdfRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplicationPdfStore = create<IApplicationPdfStore>((set) => ({
  loading: false,
  error: null,
  file: null,

  getApplicationPdf: ApiUtils.wrapperApi(async (request: ApplicationPdfRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.getPdf(request, signal);
      set({ file: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ file: null, loading: false, error: null }),
}));
